<template>
  <div class="nav">
    <div class="m_nav">
      <div class="m_nav_l">
        <h3>{{titles}}</h3>
      </div>
      <div class="m_nav_r" v-if="navState">
        <ul>
          <li v-for="(item) in titleChild" :key="item.id" >
            <router-link :to="{name:item.src}" tag="a" >{{item.name}}</router-link>
          </li>
        </ul>
      </div>
      <div class="nav_r" v-if="tipsState">
        <p>
          <i class="iconfont icon-suo"></i>
          澳門極草線上商城將對您提交的信息嚴格保密，您的個人信息僅用於您的購買及為您提供服務所用
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Nav',
    props:['titles','titleChild','navState','tipsState'],
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/Nav.vue